var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceVendorMangDelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 24,
    viewBox: "0 0 21.6 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9320",
    "data-name": "Path 9320",
    d: "M23.4,6.8H18.6V5.6A3.6,3.6,0,0,0,15,2H12.6A3.6,3.6,0,0,0,9,5.6V6.8H4.2a1.2,1.2,0,1,0,0,2.4H5.4V22.4A3.6,3.6,0,0,0,9,26h9.6a3.6,3.6,0,0,0,3.6-3.6V9.2h1.2a1.2,1.2,0,1,0,0-2.4Zm-12-1.2a1.2,1.2,0,0,1,1.2-1.2H15a1.2,1.2,0,0,1,1.2,1.2V6.8H11.4Zm8.4,16.8a1.2,1.2,0,0,1-1.2,1.2H9a1.2,1.2,0,0,1-1.2-1.2V9.2h12Z",
    transform: "translate(-3 -2)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceVendorMangDelIcon);
export default __webpack_public_path__ + "static/media/finance-vendor-mang-del-icon.b8fcb3ec0244bcf4c3231520d8240661.svg";
export { ForwardRef as ReactComponent };